export const environment = {
  production: true,
  siteTitle: 'box.moe',
  bangumiProviderBasePath: 'https://box.moe',
  kratosBasePath: 'https://auth.box.moe',
  adminUIBasePath: 'https://admin.box.moe',
  sentryDSN: 'https://d5084c2d1e0c1bfc1bfa9b88d421c12e@o337554.ingest.us.sentry.io/4506884932632576',
  turnstileSiteKey: '0x4AAAAAACLsD-FNvOZ9x0Oc',
};
